(function () {
  'use strict';

  var modal = document.getElementById('rob-lp-upgrade-modal');
  if (!modal) return;

  var acceptVariantId = modal.getAttribute('data-accept-variant-id');
  var acceptButton = modal.querySelector('[data-rob-lp-upgrade-accept]');
  var declineButtons = modal.querySelectorAll('[data-rob-lp-upgrade-decline]');

  var pendingDeclineVariantId = null;
  var pendingForm = null;
  var lastFocusedElement = null;

  function openModal(declineVariantId, triggerForm) {
    pendingDeclineVariantId = declineVariantId;
    pendingForm = triggerForm;
    lastFocusedElement = document.activeElement;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Force a reflow so the browser registers the unhidden state before we
    // add the class that animates it in — otherwise the two changes can get
    // batched into one paint and the transition never plays.
    void modal.offsetHeight;
    modal.classList.add('is-open');

    if (acceptButton) {
      acceptButton.focus();
    }
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    modal.hidden = true;

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function getLineQuantity(cart, variantId) {
    var match = cart.items.find(function (item) {
      return String(item.variant_id) === String(variantId);
    });
    return match ? match.quantity : 0;
  }

  // Ensures the cart ends up with exactly quantity 1 of targetVariantId and
  // none of otherVariantId — so the starter pack and the upgraded starter
  // pack can never both be in the cart, and re-triggering the same one
  // never stacks the quantity.
  function syncTrialPackVariant(targetVariantId, otherVariantId) {
    return fetchCart().then(function (cart) {
      var targetQty = getLineQuantity(cart, targetVariantId);
      var otherQty = otherVariantId ? getLineQuantity(cart, otherVariantId) : 0;

      if (targetQty > 0 && otherQty === 0) {
        return cart;
      }

      var updates = {};
      updates[targetVariantId] = 1;
      if (otherVariantId && otherQty > 0) {
        updates[otherVariantId] = 0;
      }

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      }).then(function (res) {
        return res.json();
      });
    });
  }

  function goToCheckout() {
    window.location.href = '/checkout';
  }

  // Intercept every trial-pack add-to-cart form on the page and show the
  // upgrade offer instead of adding straight to cart.
  document.addEventListener('submit', function (event) {
    var form = event.target.closest ? event.target.closest('.rob-lp-upsell-trigger') : null;
    if (!form) return;

    event.preventDefault();
    var variantId = form.getAttribute('data-variant-id');
    if (!variantId) {
      form.submit();
      return;
    }
    openModal(variantId, form);
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });

  function setAllBusy(busy) {
    setBusy(acceptButton, busy);
    declineButtons.forEach(function (button) {
      setBusy(button, busy);
    });
  }

  declineButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      if (!pendingDeclineVariantId) {
        closeModal();
        return;
      }

      setAllBusy(true);

      syncTrialPackVariant(pendingDeclineVariantId, acceptVariantId)
        .then(goToCheckout)
        .catch(function () {
          if (pendingForm) {
            pendingForm.submit();
          } else {
            goToCheckout();
          }
        });
    });
  });

  if (acceptButton) {
    acceptButton.addEventListener('click', function () {
      if (!acceptVariantId) return;

      setAllBusy(true);

      syncTrialPackVariant(acceptVariantId, pendingDeclineVariantId)
        .then(goToCheckout)
        .catch(goToCheckout);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
})();
